"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeliusImageUrl = exports.isAllowedExternalImageUrl = void 0;
const MaxHeliusImageBytes = 100000;
/**
 * Check if an external image URL is allowed to be loaded.
 *
 * We currently allow images from external sources which we don't control.
 * Those images could be very large. In particular, we have issues with Helius,
 * which we use for Solana asset data, which can contain images of 2-3mb. This
 * is very slow to render in the Dashboard etc.
 *
 * For Helius images, this checks the content-length before rendering/loading.
 * If the image is too large, we skip it.
 *
 * The better solution would be to resize, compress and cache the image, but we
 * don't have a framework for that yet.
 */
function isAllowedExternalImageUrl(src) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!isHeliusImageUrl(src)) {
            return true;
        }
        return isAllowedHeliusImageUrl(src);
    });
}
exports.isAllowedExternalImageUrl = isAllowedExternalImageUrl;
function isHeliusImageUrl(src) {
    try {
        const url = new URL(src);
        return url.hostname === "cdn.helius-rpc.com";
    }
    catch (_a) {
        return false;
    }
}
exports.isHeliusImageUrl = isHeliusImageUrl;
function isAllowedHeliusImageUrl(src) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(src, {
                method: "HEAD",
            });
            if (!response.ok) {
                return false;
            }
            const contentLength = response.headers.get("content-length");
            if (!contentLength) {
                return false;
            }
            const bytes = Number.parseInt(contentLength, 10);
            const contentLengthBytes = Number.isFinite(bytes) && bytes >= 0 ? bytes : undefined;
            if (!contentLengthBytes) {
                return false;
            }
            return contentLengthBytes <= MaxHeliusImageBytes;
        }
        catch (_a) {
            // If the size check fails, block the image.
            return false;
        }
    });
}
